import { fromJS } from 'immutable';
import camelcase from 'camelcase-es5';

import Lead from 'models/LeadModel';

import { combineReducerArray } from '../utils/helpers';
import { normalizeIds, normalizeModelList } from '../utils/Normalizer';

import { leads } from './types';

export * from './actions';

const initialStateList = {
  byId: {},
  ids: [],
  network: {
    loading: false,
    error: false,
  },
};

const initialState = fromJS({
  requireAction: initialStateList,
  new: initialStateList,
  active: initialStateList,
  completed: initialStateList,
});

const leadReducer = {
  [leads.request]: (state, { filter }) =>
    state.withMutations((currentState) => {
      const type = camelcase(filter);

      return currentState
        .setIn([type, 'network', 'error'], false)
        .setIn([type, 'network', 'loading'], true);
    }),
  [leads.success]: (state, { data, filter }) => {
    const type = camelcase(filter);
    const results = data.leads.map((lead) => ({ id: lead.search.id, ...lead }));

    return state.withMutations((currentState) =>
      currentState
        .setIn([type, 'network', 'loading'], false)
        .setIn([type, 'network', 'error'], false)
        .setIn([type, 'ids'], normalizeIds(results, 'id'))
        .setIn([type, 'byId'], normalizeModelList(results, Lead.deserialize, 'id')),
    );
  },
  [leads.failure]: (state, { filter }) =>
    state.withMutations((currentState) => {
      const type = camelcase(filter);

      return currentState
        .setIn([type, 'network', 'error'], true)
        .setIn([type, 'network', 'loading'], false);
    }),
};

export default combineReducerArray(initialState, [leadReducer]);
